import { render, staticRenderFns } from "./GrpInsAssignmentNew.vue?vue&type=template&id=a3a52168"
import script from "./GrpInsAssignmentNew.vue?vue&type=script&lang=js"
export * from "./GrpInsAssignmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports